"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
exports.AcCollapse = function (props) {
    var tabId = props.tabId, title = props.title, subtitle = props.subtitle, show = props.show, children = props.children;
    var _a = react_1.useState(show !== null && show !== void 0 ? show : false), open = _a[0], setOpen = _a[1];
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "rounded-sm border bg-apzlighterblue", "data-tabid": tabId },
        react_1.default.createElement(react_bootstrap_1.Card.Header, { onClick: function () { return setOpen(!open); }, className: "bg-transparent p-4" },
            react_1.default.createElement("span", { className: "d-flex flex-row align-items-center" },
                react_1.default.createElement("span", { className: "d-flex align-items-center text-primary fs-16 font-weight-bold" },
                    react_1.default.createElement("i", { className: "far " + (open ? 'fa-minus-circle' : 'fa-plus-circle') + " fa-fw fs-24 mr-3" }),
                    react_1.default.createElement("span", null, title)),
                react_1.default.createElement("span", { className: "ml-auto" }, subtitle))),
        react_1.default.createElement(react_bootstrap_1.Collapse, { in: open },
            react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-4" }, children))));
};
exports.AcCollapse.displayName = 'AcCollapse';
//# sourceMappingURL=AcCollapse.js.map